import { render } from "./Women.vue?vue&type=template&id=0a2e82ec"
import script from "./Women.vue?vue&type=script&lang=js"
export * from "./Women.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__